import React from 'react';
import PageTemplate from '../components/Layout/PageTemplate/PageTemplate';
import CommonList from '../views/CommonTableView';
const IssueRegisterPage = () => {
    return (
        <PageTemplate>
 <CommonList page={"issue_register"}/>
        </PageTemplate>
    );
};

export default IssueRegisterPage;

